import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const EvolutionAiContext = createContext(null);

export function EvolutionAiProvider({ children }) {
  const [isOpen, setOpen] = useState(false);
  const [seedMessage, setSeedMessage] = useState('');

  const openAssistant = useCallback((message = '') => {
    setSeedMessage(message);
    setOpen(true);
  }, []);

  const closeAssistant = useCallback(() => {
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      isOpen,
      setOpen,
      seedMessage,
      setSeedMessage,
      openAssistant,
      closeAssistant,
    }),
    [isOpen, seedMessage, openAssistant, closeAssistant],
  );

  return (
    <EvolutionAiContext.Provider value={value}>{children}</EvolutionAiContext.Provider>
  );
}

export function useEvolutionAi() {
  const ctx = useContext(EvolutionAiContext);
  if (!ctx) {
    throw new Error('useEvolutionAi must be used within EvolutionAiProvider');
  }
  return ctx;
}
